module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAmCAMAAACIwYlVAAAAAXNSR0IB2cksfwAAAD9QTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsyWCLwAAABV0Uk5TAF/fEG//f+/gYMBAIJ+gv/CAz3DQN2BPPAAAANRJREFUeJztkUkShCAMABFE1ODu/986mkFkCdHz1ORExS4suoUgppKyovb5qFrqY2StntHGaN12Xau1aXgc0R7OI/Q8bgd9oReuB1tGRwhXMNI4IJrtLeIQoxOJenyCCJ2X4lvUMnu8kizq8bPTemjdHv2r7RC/iv1VLMy6C/EilsuK54dYQVaPF2IlWb84HSvPCpNRZCyfVZnQM16ZxAqyWspzECvOSnt2sdKsJc94SZyV9dy17suN/j3/jGe3ZzxTfyx6JqfomcFzz0U898xO7PmeD659E6UfsKuFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/geo-layers@2x.png
// module id = 831
// module chunks = 0